/**
 * Header navigation: contact modal.
 */
(function () {
  'use strict';

  const contactLink = document.querySelector('.nav__parent-link-normal--contact');
  const contactModal = document.querySelector('.nav__contact-modal');

  // —— Contact modal: show on hover ——
  if (contactLink && contactModal) {
    contactLink.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      contactModal.classList.add('is-visible');
    });
    contactLink.addEventListener('mouseleave', (e) => {
      e.preventDefault();
      contactModal.classList.remove('is-visible');
    });
    contactModal.addEventListener('mouseleave', () => {
      contactModal.classList.remove('is-visible');
    });
  }
})();
